import { GeneratePresignedUploadUrlResponseBody, GeneratePresignedUploadUrlRequestBody } from '@boltenergy-be/shared'
import { Methods, Response } from 'types/request.ts'
import { isValidMimeType } from './utils'
import { getAxiosRequestConfigBoltBackend, newRequest } from 'utils/request.ts'

export const uploadPresigned = async (file: File): Promise<Response<string>> => {
  try {
    if (!isValidMimeType(file.type)) {
      throw new Error(`File type ${file.type} is not allowed for upload`)
    }

    // Generate presigned request body
    const presignedRequestBody: GeneratePresignedUploadUrlRequestBody = {
      contentType: file.type,
      contentLength: file.size
    }

    // Generate presigned url and key for current file
    const { data, success } = await newRequest<GeneratePresignedUploadUrlResponseBody>(
      getAxiosRequestConfigBoltBackend(Methods.POST, '/utilities/files/uploads/presign', presignedRequestBody)
    )

    if (!success || !data?.uploadUrl || !data?.key) {
      return { success: false }
    }

    // Upload the file to the received S3 upload url
    const uploadRes = await fetch(data.uploadUrl, {
      method: 'PUT',
      headers: { 'Content-Type': file.type },
      body: file
    })

    return {
      success: uploadRes.ok,
      data: data.key
    }
  } catch (error) {
    return { success: false }
  }
}
